import { useEffect, useState } from "react";
import axios from "axios";
import {
  LogOut,
  Settings,
  Users,
} from "lucide-react";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from "@/components/ui/sidebar";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { useAuth } from "@/hooks/useAuth";

import Logo from "@/assets/img/logoC3S.jpeg";
import { Link } from "react-router-dom";
import { CaseSize } from "@/components/common/ScreenDimensionForm";

const settingsMenuItems = [
  {
    title: "Paramètres",
    url: "/patient/contact",
    icon: Settings,
  },
  {
    title: "Mes séances",
    url: "/patient/seances",
    icon: Users,
  },
];

export const SidebarPatientV2 = () => {
  const { userContext, logout } = useAuth();

    const [caseSizes, setCaseSizes] = useState<CaseSize[]>([]);
    const [selectedCaseSize, setSelectedCaseSize] = useState<CaseSize | null>(null);
    

  const portal = "patient";

  useEffect(() => {
    // Récupérer les tailles de cases
    axios
      .get(`/${portal}/caseSizes`)
      .then((response) => {
        setCaseSizes(response.data);
        // Vérifier le localStorage pour la taille de case sélectionnée
        const savedCaseSizeId = localStorage.getItem("selectedCaseSizeId");
        const savedCaseSize = response.data.find(
          (cs: CaseSize) => cs.id === Number(savedCaseSizeId)
        );
        if (savedCaseSize) {
          setSelectedCaseSize(savedCaseSize);
        } else if (response.data.length > 0) {
          setSelectedCaseSize(response.data[0]);
        }
      })
      .catch((error) => {
        console.error(
          "Erreur lors de la récupération des tailles de cases:",
          error
        );
        // Gérer l'erreur de manière appropriée
      });
  }, [portal]);

  useEffect(() => {
    if (selectedCaseSize) {
      localStorage.setItem("selectedCaseSizeId", String(selectedCaseSize.id));
      localStorage.setItem("selectedCaseSizePx", String(selectedCaseSize.caseSizePx));
      localStorage.setItem("selectedCaseSizeName", selectedCaseSize.name);
    }
  }, [selectedCaseSize]);

  return (
    <Sidebar collapsible="none" className="h-full">
      <SidebarHeader className="border-b p-4">
        <div className="flex items-center space-x-2">
          <div className="h-8 w-8 rounded-lg bg-primary">
            <img
              src={Logo}
              alt="Dashboard Icon"
              className="logo size-full rounded-md"
            />
          </div>
          <div>
            <h2 className="text-md font-semibold">
              Logiciel Iron - {userContext?.clinic}
            </h2>
            <p className="text-sm text-sidebar-foreground/70">
              Portail Patient
            </p>
          </div>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <p className="mt-5 text-sm text-sidebar-foreground/70">
          {userContext?.firstName} {userContext?.lastName}
        </p>

        {caseSizes.length > 0 && (
          <div className="mt-4">
            <label htmlFor="caseSizeSelect" className="text-sm">
              Sélectionnez la taille de l'écran :
            </label>
            <div className="w-full flex justify-center">
            <Select
              value={selectedCaseSize?.id ? String(selectedCaseSize.id) : ""}
              onValueChange={(value) => {
                const selectedId = Number(value);
                const cs = caseSizes.find((cs) => cs.id === selectedId);
                setSelectedCaseSize(cs || null);
              }}
            >
              <SelectTrigger className="w-3/4 mt-1 text-black">
                <SelectValue placeholder="Choisissez une taille" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Taille de l'écran</SelectLabel>
                  {caseSizes.map((cs) => (
                    <SelectItem key={cs.id} value={String(cs.id)}>
                      {cs.name}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select></div>
          </div>
        )}

        <SidebarGroup>
          <SidebarGroupLabel>Menu principal</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {settingsMenuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <Link to={item.url}>
                      <item.icon className="h-4 w-4" />
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

      </SidebarContent>
      <SidebarFooter className="border-t p-4">
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild>
              <button className="w-full" onClick={() => logout()}>
                <LogOut className="h-4 w-4" />
                <span>Se déconnecter</span>
              </button>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
};
